
import axios from "axios";
import GLOBAL from "../Global.js";

export default class DashboardService {

    getResumenVenta(person, fechainicio, fechauno, fechafin) {
        var tipo = 8 //Tipo origen combustible
        var url1 = GLOBAL.API_GET_DASHBOARD_RESUMEN_VENTA + "?fechainicio=" + fechainicio + ".000&fechauno=" + fechauno + ".000&fechafin=" + fechafin + ".999&limite=5&tipo=" + tipo;
        return axios
            .get(url1.trim(), {
                timeout: 15000,
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(d => d.data)
            .catch((error) => console.log(error));
    }

    getResumenUltimaSemana(person) { 
        var url1 = GLOBAL.API_GET_DASHBOARD_RESUMEN_SEMANAL;
        return axios
            .get(url1.trim(), {
                timeout: 15000,
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(d => d.data)
            .catch((error) => console.log(error));
    }

    getReporteAnual(person) { 
        var url1 = GLOBAL.API_GET_DASHBOARD_REPORTE_ANUAL;
        return axios
            .get(url1.trim(), {
                timeout: 30000,
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(d => d.data)
            .catch((error) => console.log(error));
    }

    getReporteAnualCredito(person) { 
        var url1 = GLOBAL.API_GET_DASHBOARD_REPORTE_ANUAL_CREDITO;
        return axios
            .get(url1.trim(), {
                timeout: 15000,
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(d => d.data)
            .catch((error) => console.log(error));
    }
    
}